import styled from 'styled-components';





export const TabWrapper = styled.div`
    disply:flex;
    width:auto;
    overflow-x: auto;
    max-height: calc(75vh - 20px);
`;

export const LeftContainer = styled.div`
    flex: 50%; 
    
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
`;

export const Subtitle = styled.p`
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
`;

export const RightContainer = styled.div`
    flex:90%; 
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;

    @media (max-width: 768px) {
    overflow-x:auto;
    flex:0 0 100%;
    justify-content: space-between;



 
`;